import React, {useMemo, useState} from "react";
import {Grid} from "@mui/system";
import style from "../../assets/css/login-register.module.scss";
import {State, City} from "country-state-city";
import {
  Button,
  Checkbox,
  FormControlLabel,
  InputLabel,
  Tooltip,
} from "@mui/material";
import GlobalTextField from "../global-fields/GlobalTextField";
import GlobalTextAriaField from "../global-fields/GlobalTextArea";
import GlobalPassword from "../global-fields/GlobalPassword";
import {useNavigate} from "react-router-dom";
import GlobalSelectField from "../global-fields/GlobalSelectField";
import {IoIosInformationCircleOutline} from "react-icons/io";
import {useDispatch, useSelector} from "react-redux";
import {useFormik} from "formik";
import * as yup from "yup";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {setUiData} from "../../store/uiSlice";
import {selectAuthState, setAuthData} from "../../store/authSlice";
import {REGISTER_USER} from "../../constants/apiConstant";
import {useEffect} from "react";
import {removeCookies, setCookies} from "../../constants/helper";
import GlobalPhoneInput from "../global-fields/GlobalPhoneInput";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [Iagree, setIAgree] = useState(false);
  const [statesData, setStatesData] = useState([]);
  const [citiesData, setCitiesData] = useState([]);
  const {user} = useSelector(selectAuthState);

  let initialFormikVals = {
    first_name: "",
    last_name: "",
    mobile_no: "",
    company: "",
    address1: "",
    address2: "",
    country: "United States",
    state: "",
    city: "",
    zipcode: "",
    email: "",
    password: "",
    confirmPassword: "",
  };

  useEffect(() => {
    if (State) {
      let countryCode = "US";
      let allStates = State.getStatesOfCountry(countryCode);
      setStatesData(allStates);
    }
  }, [State]);
  // useEffect(() => {
  //   if (City) {
  //     let countryCode = "US"
  //     let allCities = City.getCitiesOfCountry(countryCode);
  //     setCitiesData(allCities)
  //   }
  // }, [City])

  const handleRegister = async (e) => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {...e};
    if (user?.user_type === "agent") {
      data = {...data, agent_id: user?.id};
    }
    const options = {
      method: REGISTER_USER.method,
      headers: REGISTER_USER.headers,
      body: JSON.stringify(data),
    };

    fetch(REGISTER_USER.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          if (res.errors) {
            GlobalNotificationPopup({
              type: "error",
              message: res?.errors.email,
            });
          } else {
            GlobalNotificationPopup({type: "error", message: res?.message});
          }
          removeCookies("isLogin");
        } else if (res.status == 1) {
          GlobalNotificationPopup({type: "success", message: res?.message});
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          if (user?.user_type === "agent") {
            navigate(`/clients`);
            return;
          }
          dispatch(
            setAuthData({
              user_id: res?.user_id,
            })
          );
          setCookies("isLogin", "true");
          navigate(`/login`);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues: initialFormikVals,
    onSubmit: (values) => {
      if (!Iagree) {
        GlobalNotificationPopup({
          type: "warning",
          message: "Please Agree To All Terms & Conditions and Privacy Policy.",
        });
        return;
      }
      delete values.confirmPassword;
      handleRegister(values);
    },
    validationSchema: yup.object().shape({
      first_name: yup
        .string()
        .trim()
        .required("First Name is required!")
        .min(2, "First Name must be at least 2 characters."),
      last_name: yup
        .string()
        .trim()
        .required("Last Name is required!")
        .min(2, "Last Name must be at least 2 characters."),
      // mobile_no: yup
      //   .string()
      //   .required("Mobile Number is required!")
      //   .matches(
      //     /^[0-9]{8,}$/,
      //     "Enter a valid mobile number with at least 8 digits."
      //   ),
      mobile_no: yup
        .string()
        .required("Mobile Number is required!")
        .matches(/^[+()\-.\s\d]+$/, "Enter a valid mobile number."),
      company: yup.string().trim().required("Company Name is required!"),
      address1: yup
        .string()
        .trim()
        .required("Company Address Line 1 is required!"),
      address2: yup.string().trim().notRequired(),
      state: yup.string().required("State is required!"),
      // .oneOf(usStates, "Enter a valid US state."),
      city: yup
        .string()
        .trim()
        .required("City is required!")
        .test(
          "city-requires-state",
          "Please select a state before selecting a city!",
          function (value) {
            // Access the `state` value using `this.parent`
            const state = this.parent.state;
            return Boolean(state); // Return true only if state is selected
          }
        ),
      zipcode: yup
        .string()
        .required("Zip Code is required!")
        .matches(
          /^\d{5}(-\d{4})?$/,
          "Enter a valid US zip code (e.g., 12345 or 12345-6789)."
        ),
      email: yup
        .string()
        .email("Enter a valid email address!")
        .required("Email is required!"),
      password: yup
        .string()
        .trim()
        .required("Password is required!")
        .matches(
          /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/,
          "Password must be at least 8 characters long, include 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number."
        ),
      confirmPassword: yup
        .string()
        .trim()
        .required("Confirm Password is required!")
        .oneOf([yup.ref("password"), null], "Passwords must match."),
    }),
  });

  const statesArr = useMemo(() => statesData, [statesData]);

  const makeCityData = (e) => {
    let filteredCity = statesArr.find((item) => item.name === e);

    let c = City.getCitiesOfState(
      filteredCity.countryCode,
      filteredCity.isoCode
    );

    setCitiesData(c);
  };

  const citiesArr = useMemo(() => citiesData, [citiesData]);

  // console.log("citiesArr", citiesArr);
  // console.log("FORMIK", formik);

  return (
    <>
      {/* <div
        style={{
          position: "relative",
          width: "90%",
          padding: "10px 0px 0px 20px",
          marginTop: "10px",
        }}
      >
        <Link to="/">
          <img className={style.registerLogoMain} src={Logo} width={200} />
        </Link>
      </div> */}
      <div
        className={user?.user_type === "agent" ? {} : style.registerMainWrapper}
      >
        <div className={style.regiterLeftMain}>
          <Grid
            container
            spacing={1}
            justifyContent="center"
            className="customeContainer"
          >
            <Grid size={{xs: 12, lg: 7, xl: 6}}>
              <div className={style.log_title}>
                <h2>
                  Register{" "}
                  {user?.user_type === "agent" ? "a Client" : null}{" "}
                </h2>
                <p>
                  {" "}
                  {user?.user_type === "agent"
                    ? "Let’s create account for your client"
                    : "Welcome, Let’s create your account"}{" "}
                </p>
              </div>

              <form
                autoComplete="false"
                autoSave="false"
                onSubmit={formik.handleSubmit}
              >
                <Grid container spacing={2} justifyContent="center">
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      First Name*
                    </InputLabel>

                    <GlobalTextField
                      id="first_name"
                      name="first_name"
                      type="text"
                      value={formik.values.first_name}
                      onChange={(e) =>
                        formik.setFieldValue("first_name", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.first_name &&
                        Boolean(formik.errors.first_name)
                      }
                      helperText={
                        formik.touched.first_name && formik.errors.first_name
                      }
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Last Name*
                    </InputLabel>

                    <GlobalTextField
                      id="last_name"
                      name="last_name"
                      type="text"
                      value={formik.values.last_name}
                      onChange={(e) =>
                        formik.setFieldValue("last_name", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.last_name &&
                        Boolean(formik.errors.last_name)
                      }
                      helperText={
                        formik.touched.last_name && formik.errors.last_name
                      }
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Mobile number*
                    </InputLabel>

                    {/* <GlobalTextField
                      id="mobile_no"
                      name="mobile_no"
                      type="text" // Keeping it as text because we handle the validation in onChange
                      value={formik.values.mobile_no}
                      onChange={(e) => {
                        // Allow only numbers (integer values) to be typed
                        const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                        formik.setFieldValue("mobile_no", value); // Set the numeric value
                      }}
                      onBlur={formik.handleBlur}
                      error={formik.touched.mobile_no && Boolean(formik.errors.mobile_no)}
                      helperText={formik.touched.mobile_no && formik.errors.mobile_no}
                    /> */}

                    <GlobalPhoneInput
                      id="mobile_no"
                      name="mobile_no"
                      value={formik.values.mobile_no}
                      onChange={({value, countryDetails, formattedVal}) => {
                        //const value = e.target.value.replace(/[^0-9]/g, "");
                        formik.setFieldValue("mobile_no", formattedVal);
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.mobile_no &&
                        Boolean(formik.errors.mobile_no)
                      }
                      helperText={
                        formik.touched.mobile_no && formik.errors.mobile_no
                      }
                      cssClass={""}
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Email Address*
                    </InputLabel>

                    <GlobalTextField
                      id="email"
                      name="email"
                      type="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>

                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <div className={style.logPassField}>
                      <InputLabel
                        sx={{mb: 1}}
                        htmlFor="outlined-adornment-password"
                        style={{color: "black"}}
                      >
                        Password*
                      </InputLabel>

                      <GlobalPassword
                        id="password"
                        name="password"
                        type="password"
                        //placeH="Enter your password"
                        label="Password"
                        value={formik.values.password}
                        onChange={(e) =>
                          formik.setFieldValue("password", e.target.value)
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.password &&
                          Boolean(formik.errors.password)
                        }
                        helperText={
                          formik.touched.password && formik.errors.password
                        }
                      />
                    </div>
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <div className={style.logPassField}>
                      <InputLabel
                        sx={{mb: 1}}
                        htmlFor="outlined-adornment-confirm-password"
                        style={{color: "black"}}
                      >
                        Confirm password*
                      </InputLabel>

                      <GlobalPassword
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        //placeH="Enter your Confirm Password"
                        label="confirmPassword"
                        value={formik.values.confirmPassword}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "confirmPassword",
                            e.target.value
                          )
                        }
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.confirmPassword &&
                          Boolean(formik.errors.confirmPassword)
                        }
                        helperText={
                          formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                        }
                      />
                    </div>
                  </Grid>

                  <Grid size={{xs: 12, lg: 12}} className={style.logLabel}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Company Name*
                    </InputLabel>

                    <GlobalTextField
                      id="company"
                      name="company"
                      type="text"
                      value={formik.values.company}
                      onChange={(e) =>
                        formik.setFieldValue("company", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.company && Boolean(formik.errors.company)
                      }
                      helperText={
                        formik.touched.company && formik.errors.company
                      }
                    />
                  </Grid>
                  {/* <Grid size={{ xs: 12, lg: 6 }} className={style.logLabel}>
                    <InputLabel
                      sx={{ mb: 1 }}
                      htmlFor="my-input"
                      style={{ color: "black" }}
                    >
                      Fax Number
                    </InputLabel>
                    
                      <GlobalTextField type="text" />
                    
                  </Grid> */}
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Company address Line 1*
                    </InputLabel>

                    <GlobalTextAriaField
                      row="2"
                      id="address1"
                      name="address1"
                      type="text"
                      value={formik.values.address1}
                      onChange={(e) =>
                        formik.setFieldValue("address1", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.address1 &&
                        Boolean(formik.errors.address1)
                      }
                      helperText={
                        formik.touched.address1 && formik.errors.address1
                      }
                    />
                  </Grid>

                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Company address Line 2
                    </InputLabel>

                    <GlobalTextAriaField
                      row="2"
                      id="address2"
                      name="address2"
                      type="text"
                      value={formik.values.address2}
                      onChange={(e) =>
                        formik.setFieldValue("address2", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.address2 &&
                        Boolean(formik.errors.address2)
                      }
                      helperText={
                        formik.touched.address2 && formik.errors.address2
                      }
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      State*
                    </InputLabel>
                    <GlobalSelectField
                      labelId="state-select"
                      value={formik.values.state}
                      onChange={(e) => {
                        setCitiesData([]);
                        formik.setFieldValue("state", e.target?.value);
                        makeCityData(e.target.value);
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.state && Boolean(formik.errors.state)
                      }
                      helperText={formik.touched.state && formik.errors.state}
                      menuItems={statesArr}
                      isStateOrCity
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      City*
                    </InputLabel>
                    <GlobalSelectField
                      labelId="city-select"
                      value={formik.values.city}
                      onChange={(e) => {
                        if (!formik.values.state) {
                          GlobalNotificationPopup({
                            type: "warning",
                            message: "Please select a State first!",
                          });
                          return;
                        }
                        if (citiesArr.length === 0) {
                          GlobalNotificationPopup({
                            type: "error",
                            message:
                              "No cities available for the selected state!",
                          });
                          return;
                        }
                        formik.setFieldValue("city", e.target.value);
                      }}
                      onBlur={formik.handleBlur}
                      error={formik.touched.city && Boolean(formik.errors.city)}
                      helperText={formik.touched.city && formik.errors.city}
                      menuItems={
                        citiesArr.length > 0
                          ? citiesArr
                          : [{name: "Select State First!", value: ""}]
                      }
                      isStateOrCity
                      disabled={formik.values.state === ""}
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Zip*
                    </InputLabel>

                    <GlobalTextField
                      id="zipcode"
                      name="zipcode"
                      type="text"
                      value={formik.values.zipcode}
                      onChange={(e) =>
                        formik.setFieldValue("zipcode", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.zipcode && Boolean(formik.errors.zipcode)
                      }
                      helperText={
                        formik.touched.zipcode && formik.errors.zipcode
                      }
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 6, sm: 6}}
                    className={style.logLabel}
                  >
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Country
                      <Tooltip
                        arrow
                        placement="right"
                        title="Default Country - United States, Can’t be changed."
                      >
                        <IoIosInformationCircleOutline
                          style={{marginLeft: "5px"}}
                        />
                      </Tooltip>
                    </InputLabel>

                    <GlobalTextField
                      type="text"
                      disabled={true}
                      value={"United States"}
                    />
                  </Grid>

                  <Grid size={{xl: 12, xs: 12}} className={style.logLabel}>
                    <div
                      className={`${style.log_checkbox} ${style.RegisterCheckbox} `}
                    >
                      <FormControlLabel
                        sx={{width: "auto"}}
                        className={style.LogRemember}
                        control={
                          <Checkbox
                            value={Iagree}
                            onChange={(e) => {
                              setIAgree(e.target.checked);
                            }}
                          />
                        }
                        label="I agree to all Terms & Conditions and Privacy Policy"
                      />
                    </div>
                    <div className={style.logBtnMain}>
                      <Button fullWidth variant="contained" type="submit">
                        Register
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default Register;
